<template>
<div>
  <!-- <section class="tax-modal-mask">
  </section> -->
	<div class="container">
		<div class="space-100"></div>
		<div class="row first-secction">
			<div class="col-sm-4 text-center">
        <canvas class="QR" id="barcode"></canvas>
				<div>
					<p class="count-title">No. de cuenta</p>
					<h4 class="count-info">{{userData.cuenta}}</h4>
					<h4 class="count-info">Clave: <br> {{password}}</h4>
				</div>
        <div v-if="activeButton">
          <button v-if="showValidate && showValidateSucess " class="valid-button" @click="ValidateAccount()">Validar cuenta</button> 
          <button v-if="!showValidate" class="valid-button-loader"><img class="loader-input" src="../../public/img/Rolling.gif" alt=""></button> 
          <button v-if="!showValidateSucess" class="valid-button-sucess"><img class="valid-checkout-sucess" src="../assets/assets_loyalty/loyalty website-35.png"></button> 
          <button class="status-icon-button" v-popover:popover4 type="default"><img src="../assets/assets_loyalty/pregunta.png" alt=""></button>
          <popover ref="popover4" popper-class="popover text-center"  width="200" trigger="hover">
            <div class="popover-body">{{statusMessage}}</div>
          </popover>
        </div>
        <div v-if="frozenAccount">
          <p class="frozen-title">Cuenta congelada</p><button class="status-icon-button" v-popover:popover4 type="default"><img src="../assets/assets_loyalty/informacion.png" alt=""></button>
          <popover ref="popover4" popper-class="popover text-center"  width="200" trigger="hover">
            <div class="popover-body test">{{statusMessage}}</div>
          </popover>
        </div>
      </div>
      <div class="col-sm-8">
				<div>
          <h2 class="margin-defult name-user">{{userData.nombre}} {{userData.apellidos}}</h2>
        </div>
        <div class="text-right">
        	<router-link class="nav-link trans-resposive"  to="/PerfilUsuario/transacciones">
          	<a class="text-color-blue" href="">Ver Transacciones <img src="../assets/assets_loyalty/flecha-derecha.png"></a>
          </router-link>
        </div>
        <div class="row">
        	<div class="col-sm-4">
          	<p>Saldo acumulado</p>
            <h3>${{totalBalance}}</h3>
				</div>
        <div class="col-sm-4">
        	<p>A vencer en {{monthBeat}}</p>
          <h3>${{balanceDue}}</h3>
        </div>
      </div>
      <div>
      	<div class="row line-border">
      		<h4 class="money-title"><img class="icon-title" src="../assets/assets_loyalty/assets-24.png"> Dinero Disponible</h4>
        </div>
        <div class="text-right more-info-space">
        </div>
        <div class="row saldo-responsive">
        	<div v-for="item of saldos" :key="item.id" class="text-center">
						<button class="item-money-avalivable">
              <div v-if="item.logo != null">
							<img class="item-money-avalivable-merchant-logo" :src="item.logo" alt="">
              </div>
              <div v-else>
  							<img class="item-money-avalivable-logo-default" src="https://loyaltymailing.blob.core.windows.net/loyaltyrefunds/logo_lr_color.png" alt="">
              </div>
            	<p class="margin-defult">Saldo disponible</p>
            	<h4 class="margin-defult">${{item.saldo}}</h4>
						</button>
          </div>
          <div class="col-sm-2 borders-defult" v-if="showMoreCommers">
            <router-link  to="/PerfilUsuario/comercios">
              <button class="item-money-avalivable-show-more-button">
                <p class="item-money-avalivable-show-more-text">Ver todos los comercios afiliados</p>
                <img src="../assets/assets_loyalty/mas.png" alt="">
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="space-50"></div>
      <div>
        <div class="row line-border">
          <h4 class="money-title" v-show="eyelashView"><img class="icon-title" src="../assets/assets_loyalty/assets-27.png"> Mis cupones</h4>
        </div>
        <div class="text-right more-info-space">
        	<!-- <router-link class="nav-link"  to="/PerfilUsuario/cupones">
          	<a class="text-color-blue" href="#">Ver todos <img src="../assets/assets_loyalty/flecha-derecha.png"></a>
          </router-link> -->
        </div>
        <div class="row cupons-area">
          <div class="cupon-item-area" v-for="cupon of cuponesLogo" :key="cupon.id">
            <button class="cupon-item-button" @click="show(cupon.comercio, cupon.cupones)">
              <div class="cupon-item-logo-area" v-if="cupon.logo != null">
                <img class="cupon-item-logo" :src="cupon.logo" alt="">
              </div>
              <div class="cupon-item-logo-area" v-else>
                <img  src="../assets/assets_loyalty/assets-19.png" alt="">
              </div>
              <div>
                <p>{{cupon.comercio}}</p>
              </div>
            </button>
          </div>
          <modal :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{comercio}}</h4>
            <div class="cupones-item-model" v-for="item of cupones" :key="item.id">
              <div class="row">
                <div class="col-sm-6 info-modal-text">
                  <div class="row">
                  </div>
                  <div class="row">
                    <label>Cupon </label>
                    <strong>: {{item.cupon}}</strong>
                  </div>
                  <div class="row">
                    <label>Puntos </label>
                    <strong>: {{item.puntos}} pts</strong>
                  </div>
                  <div class="row">
                    <label>Codigo </label>
                    <strong>: {{item.codigo}}</strong>
                  </div>
                  <div class="row">
                    <label>Vigencia </label>
                    <strong>: {{item.vigencia}}</strong>
                  </div>
                </div>
                <div class="col-sm-6 text-center">
                  <h2 class="cupones-concepto-modal">
                      {{item.concepto}}
                    </h2>
                </div>
              </div>
            </div>
          </modal>
        </div>
      </div>
      <div class="space-50"></div>
      	<div>
        	<div class="row line-border is-resposive">
          	<div class="col-sm-9 is-resposive">
            	<h4 class="money-title"><img class="icon-info" src="../assets/assets_loyalty/assets-26.png"> Información</h4>
            </div>
            <div class="col-sm-3 text-right editar-button is-resposive">
            	<router-link class="nav-link"  to="/PerfilUsuario/EditarPerfil">
								<a class="text-color-blue" href="#">Editar <img src="../assets/assets_loyalty/flecha-derecha.png"></a>
              </router-link>
            </div>
          </div>
        	<div class="row line-border">
            <h4 class="money-title link-resposive"><img class="icon-info" src="../assets/assets_loyalty/assets-26.png"> Información</h4>
            <router-link class="nav-link link-resposive"  to="/PerfilUsuario/EditarPerfil">
						  <a class="text-color-blue link-resposive text-color-blue-resp" href="#">Editar <img src="../assets/assets_loyalty/flecha-derecha.png"></a>
            </router-link>
          </div>
          <div class="row row-info">
          	<div class="col-sm-4">
            	<p><strong>Teléfono</strong></p> 
						</div>
						<div class="col-sm-5 ">
							<p class="text-color-blue">{{userData.cel}}</p>
						</div>
					</div>
					<div class="row row-info">
						<div class="col-sm-4">
							<p> <strong>Correo electrónico</strong></p> 
						</div>
						<div class="col-sm-5 ">
							<p class="text-color-blue">{{userData.email}}</p>
            </div>
					</div>
					<div class="row row-info">
						<div class="col-sm-4">
							<p><strong> Fecha de nacimiento</strong></p> 
						</div>
						<div class="col-sm-5">
							<p class="text-color-blue">{{userDayBDay}}/{{userMonthBDay}}/{{userYearBDay}}</p>
						</div>
					</div>
					<div class="row row-info">
						<div class="col-sm-4">
							<p> <strong>Código postal</strong></p>
						</div>
						<div class="col-sm-5">
							<p class="text-color-blue">{{userData.codigo_postal}}</p>
						</div>
					</div>
          <div class="row row-info">
						<div class="col-sm-4">
							<p><strong> Sexo </strong></p> 
						</div>
						<div class="col-sm-5">
							<p class="text-color-blue">Masculino</p>
						</div>
					</div>
        </div>
      </div>
    </div>
  </div>
  <loader v-if="loaderActive"></loader>
</div>
</template>
<script>
import { Card, FormGroupInput, Button, Tabs, TabPane, Modal} from '@/components';
import ProfileService from '../service/core/profile.service'
import Loader from './components/loader'
import moment from 'moment';
import { Popover } from 'element-ui'
import bwipjs from 'bwip-js';
import qrcode from 'qrcode-generator';
import generateBarcode from "pdf417";

moment.locale('es');

export default {
  components: {
    Card,
    Tabs,
    Loader,
    TabPane,
    Modal,
    Popover,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data(){
    return {
        modals: {
            classic: false,
        },
        eyelashView: true,
        eyelashView2:false,
        profileService: new ProfileService(),
        monthBeat: '',
        userData: '',
        userDayBDay: '',
        userYearBDay: '',
        userMonthBDay: '',
        cuponesLogo: [],
        cuponesData: [],
				totalBalance: '',
        saldos: '',
        balanceDue: '',
        password:'',
        activeButton: false,
        statusMessage: '',
        showMoreCommers: false,
        frozenAccount: false,
        comercio: '',
        cupones: '',
        loaderActive: false,
        showValidate: true,
        showValidateSucess: true,
        test: ''
    }
  },
  mounted(){
    this.searchAcountInfo()
    this.monthBeat = moment().add(1, 'month').format('MMMM') 
    console.log('HERE ARE SESSION:', sessionStorage.getItem('Validar'))
    if(`${sessionStorage.getItem('Validar')}` === 'true'){
      this.showValidate = true
      this.showValidateSucess = false
    }
  },
  methods:{
    show(comercio, cupones){
      this.modals.classic = true
      this.comercio = comercio
      this.cupones = cupones
    },
    ValidateAccount(){
      this.showValidate = false
			this.profileService.accountValidate().then(data => {
        sessionStorage.setItem('Validar', 'true');
        this.showValidate = true
        this.showValidateSucess = false
        this.$notify({
          group: 'foo',
          type: 'success',
          title: '¡Listo!',
          text: 'Te enviamos un correo para validar tu cuenta.'
        });
      }, err => {
        this.showValidate = true
        this.$notify({
          group: 'foo',
          type: 'error',
          title: ':(',
          text: 'Algo salio mal, intetalo de nuevo.'
        });
      })
    },
  searchAcountInfo(){
    this.loaderActive = true
			this.profileService.account().then(data => {
      this.loaderActive = false
        let imgId = document.getElementById('avatar')
        this.userData = data.data.result
        let Bday = data.data.result.fecha_nacimiento.split('-')
        this.userDayBDay = Bday[2]
        this.userYearBDay = Bday[0]
        this.userMonthBDay = Bday[1]
        this.saldos = data.data.result.saldos
        this.balanceDue = data.data.result.saldoPorVencer
				this.totalBalance = data.data.result.saldoAcumulado
        this.password = data.data.result.password
        var canvas = document.getElementById("barcode")
        PDF417.draw(`${data.data.result.cuenta}`, canvas)
        // var typeNumber = 20;
        // var errorCorrectionLevel = 'H';
        // var qr = qrcode(typeNumber, errorCorrectionLevel);
        // qr.addData(`${data.data.result.cuenta}`);
        // qr.make();
        // document.getElementById('placeHolder').innerHTML = qr.createImgTag();
        for(let cupon of data.data.result.cupones){
          if(cupon.cupones.length !== 0){
            this.cuponesLogo.push(cupon)
            this.cuponesData.push(cupon.cupones)
          }
        }

        if(this.saldos.length >= 6){
          this.showMoreCommers = true
        }else{
          this.showMoreCommers = false
        }
        if(data.data.result.estatus === 'ACTIVA' && data.data.result.cuenta_validada === 0){
          this.activeButton = true
          this.statusMessage = 'Valida tu cuenta para tener acceso a todos los beneficios de nuestros afiliados '
        }else if(data.data.result.estatus === 'ACTIVA' && data.data.result.cuenta_validada === 1){
          this.activeButton = false 
        }else if(data.data.result.estatus === 'CONGELADA'){
          this.frozenAccount = true
          this.statusMessage = 'Tenemos inconvenientes con tu cuenta, favor de contactar a soporte@loyaltyrefunds.com'
        }
      }, err => {
      })
		},
    eyelash1(event) {
        this.eyelashView = true
        this.eyelashView2 = false
        var button = document.getElementById('button')
        var button2 = document.getElementById('button2')
        button2.classList.remove("eyelash-active");
        button.classList.add("eyelash-active");
    },
    eyelash2(event) {
        this.eyelashView = false
        this.eyelashView2 = true
        var button = document.getElementById('button')
        var button2 = document.getElementById('button2')
        button.classList.remove("eyelash-active");
        button2.classList.add("eyelash-active");

    }
  }
}
</script>
<style lang="scss">
#javascriptComponents {
  .modal-buttons,
  .popover-buttons,
  .tooltip-buttons {
    .btn + .btn {
      margin-left: 3px;
    }
  }
}
.tab-content.tab-content-padding {
  padding: 20px;
}
.more-info-space{
    margin: 10px 0px 10px 10px;
}
.margin-defult{
    margin: 0px;
}
.count-title{
    margin: 0px;
}
.item-money-avalivable-logo-default{
  max-width: 65px;
  margin: 5px;
}

.item-money-avalivable-merchant-logo{
  max-width: 90px;
  margin: 5px;
}

.item-money-avalivable-button{
	border: 0px;
	background-color: #ffffff00
}
.item-money-avalivable{
  max-width: 120px;
  height: 170px;
  font-size: 12px;
  margin: 5px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5)
}
.count-info{
    margin: 10px;
}

.text-color-blue{
    color: #00bbff;
}
.money-title{
    margin: 50px;
}
.line-border{
    border-bottom: 1px solid #7e7e7e67;
}
.icon-title{
    width: 25px;
}
.comer-img{
    width:65%;
    margin: 10px;
}
.borders-defult{
    width: 23%;
    padding: 5px;
    margin: 5px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.cupon-logo-defult{
  margin-top: 40px;
}
.item-money-avalivable-show-more-text{
  font-size: 15px;
  color: #00bbff;
}

.item-money-avalivable-show-more-button{
  margin: 5px;
  border: 0px;
	background-color: #ffffff00
}
.validity-date{
    margin: 0px;
    font-size: 10px;
    padding-left: 140px;
}
.row-info{
    margin: 10px;
}
.editar-button{
    margin-top: 10px;
}
.icon-info{
    width: 20px;
}
.promo-img{
    width: 35%;
    margin: 10px 100px 5px 100px;
}
.eyelash{
    background-color: #ffffff;
    border: 0px;
}
.mystyle {
    color:#000000;
    background-color:#ff0000;
}
.mystyle2 {
    background-color: #00bbff;
}
.eyelash-active{
    border: 0px;
    border-bottom: 2px solid #00bbff
}
.commerce-promotions{
    font-weight: bold;
    color:#00bbff;
    margin: 0px;
}

.cupons-area{
  width: 100%;
  max-height: 210px;
  // overflow-x: scroll;	
}

.cupon-item-button{
  max-width: 200px;
  height: 80px;
  font-size: 12px;
  margin: 5px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5)
}

.cupon-item-area{
  max-width: 50%;
  display: inline-flex;
}
.status-icon-button{
  background-color: #ffffff00;
  margin-left: 5px;
  padding: 0px;
  border: 0px;
}
.valid-button{
  width: 50%;
  height: 40px;
  background-color: #00bbff;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
  border: 0px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
}

.valid-button-loader{
  width: 50%;
  height: 40px;
  background-color: #f0f0f0;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
  border: 0px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
}

.frozen-title{
  color: #ff0000;
  font-size: 15px;
  display: inline;
}

.test{
  background-color: #ff00002d;
  color: #ff0000;
}

.cupon-item-logo-area{
  max-width: 100%;
  margin-bottom: 10px;
}

.cupon-item-logo{
  max-width: 50%;
}

.item-money-avalivable-info{
  //   width: 100%;
  // height: 100vh;
  // position: fixed;
  // background-color: rgba(0, 0, 0, .5);
}
    
.cupones-item-model{
  font-size: 12px;
  margin: 10px;
  padding: 25px;
  background-color: #ffffff;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5)
}

.cupones-concepto-modal{
  margin: 0px;
  margin-top: 30px;
}

.info-modal-text{
  font-size: 10px;
}

.QR{
  width: 190px;
}

.valid-button-sucess{
  width: 50%;
  height: 40px;
  background-color: #2fac65bb;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
  border: 0px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
}

.valid-checkout-sucess{
  width: 30px;
}

.line-border-resposive{
  display: none;
}

.link-resposive{
  display: none;
}

@media screen and (min-width: 321px) and (max-width: 768px) { 
  .is-resposive{
    display: none;
    border: 0px;
  }
  .link-resposive{
    display: block;
  }
  .first-secction{
    width: 100%;
    text-align: center;
  }
  .line-border{
    margin-left: 0px;
  }
  .trans-resposive{
    text-align: center;
  }
  .saldo-responsive{
    padding: 15px;
  }
  .cupons-area{
    padding: 15px;
  }
  .text-color-blue-resp{
    margin-left: 75px;
  }
}
</style>
